export default "__VITE_ASSET__WtBMR77F__"